import { createAction } from "redux-actions";

import {
  GET_WATCH_LIST_ENTRIES_BY_WATCH_LIST,
  GET_WATCH_LIST_ENTRY_BY_WATCH_LIST,
  SET_WATCH_LIST_ENTRY_BY_WATCH_LIST_SEARCH_FILTERS,
  GET_WATCH_LIST_ENTRIES_BY_WATCH_LIST_COUNT,
  SET_ITEMS_PER_PAGE_WATCHLIST_ENTRY_BY_WATCHLIST_TYPE,
  SET_CURRENT_PAGE_WATCHLIST_ENTRY_BY_WATCHLIST_TYPE,
} from "../types";
import createAsyncActions from "../../../utilities/createAsyncActions";

export const {
  getWatchListEntriesByWatchList,
  getWatchListEntriesByWatchListPending,
  getWatchListEntriesByWatchListFulfilled,
  getWatchListEntriesByWatchListRejected,
} = createAsyncActions(
  GET_WATCH_LIST_ENTRIES_BY_WATCH_LIST,
  "getWatchListEntriesByWatchList"
);

export const {
  getWatchListEntriesByWatchListCount,
  getWatchListEntriesByWatchListCountPending,
  getWatchListEntriesByWatchListCountFulfilled,
  getWatchListEntriesByWatchListCountRejected,
} = createAsyncActions(
  GET_WATCH_LIST_ENTRIES_BY_WATCH_LIST_COUNT,
  "getWatchListEntriesByWatchListCount"
);

export const {
  getWatchListEntryByWatchList,
  getWatchListEntryByWatchListPending,
  getWatchListEntryByWatchListFulfilled,
  getWatchListEntryByWatchListRejected,
} = createAsyncActions(
  GET_WATCH_LIST_ENTRY_BY_WATCH_LIST,
  "getWatchListEntryByWatchList"
);

export const setWatchListEntryByWatchListSearchFilters = createAction(
  SET_WATCH_LIST_ENTRY_BY_WATCH_LIST_SEARCH_FILTERS
);

export const setCurrentPageWatchListEntryByWatchList = createAction(
  SET_CURRENT_PAGE_WATCHLIST_ENTRY_BY_WATCHLIST_TYPE
);

export const setItemsPerPageWatchListEntryByWatchList = createAction(
  SET_ITEMS_PER_PAGE_WATCHLIST_ENTRY_BY_WATCHLIST_TYPE
);



// WEBPACK FOOTER //
// ./src/features/watch-list-entry/actions/getWatchListEntriesByWatchListActions.js